<template>
  <a-row class="top-content">
    <a-col :span="6" class="top-content-left">
      <left-tabs
        @changeTab="changeTab"
        @selectTree="selectTree"
        @load="loadTree"
        :selectedKeys="selectedKeys"
        :back="back"
        :loading="loading"
      ></left-tabs>
    </a-col>
    <a-col :span="18" style="padding: 8px;height: 100%">
      <a-spin size="large" v-if="loading" :spinning="loading" class="spin-custom"> </a-spin>
      <div class="top-content-header">
        <a-button v-if="tabKey == '1'" @click="backTree">
          {{ $t('page_dnc_source_return_to') }}
        </a-button>
        <a-input
          :style="{ width: 'calc(100% - ' + (tabKey == '1' ? '209' : '98') + 'px)' }"
          @change="changeFilter"
          :placeholder="$t('page_dnc_source_double_click_open')"
        ></a-input>
        <a-radio-group :value="fileType" @change="changeType" button-style="solid">
          <a-radio-button value="list">
            <a-icon type="menu" />
          </a-radio-button>
          <a-radio-button value="file">
            <a-icon type="appstore" />
          </a-radio-button>
        </a-radio-group>
      </div>
      <div v-if="!selectedKeys.length" class="empty-content">
        <a-empty :description="$t('page_dnc_source_select_process')" />
      </div>
      <component
        v-else
        :is="componentId"
        :fileType="fileType"
        :keyWords="keyWords"
        @doTransmission="(list) => doTransmission(list)"
        @dblclickFlor="(value) => dblclickFlor(value)"
        :selectedKey="selectedKeys.length ? selectedKeys[0] : ''"
      ></component>
    </a-col>
  </a-row>
</template>

<script>
import LeftTabs from './LeftTabs.vue' // tab选择
import MyDocuments from './MyDocuments.vue' // 本地文件
import ProcessManagement from './ProcessManagement.vue' // 工艺管理
export default {
  components: {
    LeftTabs,
    MyDocuments,
    ProcessManagement
  },
  props: {
    fileType: {
      type: String,
      default: 'file'
    }
  },
  data() {
    return {
      selectedKeys: [], // 选中树节点
      tabKey: '1',
      back: 0, //控制返回上级
      timer: null,
      keyWords: '',
      targetList: [],
      loading: false
    }
  },
  computed: {
    componentId() {
      let key = ''
      switch (this.tabKey) {
        case '1':
          key = 'my-documents'
          break
        case '2':
          key = 'process-management'
          break
        default:
          key = 'my-documents'
          break
      }
      return key
    }
  },
  methods: {
    loadTree(value) {
      this.loading = value
    },
    backTree() {
      if (this.timer) {
        clearTimeout(this.timer)
        this.timer = null
      }
      this.timer = setTimeout(() => {
        this.back += 1
      }, 50)
    },
    changeFilter(value) {
      this.keyWords = value.target.value
    },
    changeTab(value) {
      this.tabKey = value
    },
    selectTree(selectedKeys) {
      this.selectedKeys = selectedKeys
    },
    dblclickFlor(file) {
      this.selectedKeys = [file.id]
    },
    changeType(value) {
      this.$emit('changeType', value.target.value)
    },
    doTransmission(targetList) {
      this.targetList = targetList
      this.$emit('doTransmission', targetList, this.tabKey)
    }
  }
}
</script>

<style lang="less" scoped>
.top-content {
  height: calc(50% - 4px);
  width: 100%;
  border: 1px solid #d8d8d8;
  background-color: #ffffff;
  &-left {
    border-right: 1px solid #d8d8d8;
    height: 100%;
    overflow: hidden;
  }
  .top-content-header {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    justify-content: space-between;
    align-items: center;
  }
  .empty-content {
    border: 1px solid #d8d8d8;
    margin-top: 6px;
    height: calc(100% - 38px);
    background-color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .spin-custom {
    height: 100%;
    position: absolute;
    left: 0px;
    top: 0px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: hsla(213, 100%, 94%, 0.75);
    z-index: 8;
  }
}
</style>
